import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import $ from "jquery";
import "@fortawesome/fontawesome-free/css/all.min.css";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";
import config from "../../config";
import { useNavigate } from "react-router-dom";
function ListContainer({ studentId, setStudentId , improvementCandidateIds , setImprovementCandidateIds , supplementaryCandidateIds , setSupplementaryCandidateIds}) {
  const navigate = useNavigate();
  const tableRef = useRef(null);
  const [students, setStudents] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]); // Stores search results
  const [loading, setLoading] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const iframeRef = useRef(null);
  const [checklistData, setChecklistData] = useState("");
  useEffect(() => {
    const token = localStorage.getItem("token");
    const centCode = localStorage.getItem("CentCode");

    if (!token) {
      navigate("/");
      return;
    }

    setLoading(true);
    axios
      .post(
        `${config.API_BASE_URL}/Auth/GetStudentData`,
        { cenT_CODE: centCode },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        if (response.data.status === 200 && response.data.data.school_data.length > 0) {
          const studentData = response.data.data.school_data;
          setStudents(studentData);
          setFilteredStudents(studentData);

          // Store candidate IDs as comma-separated strings
          const improvementIds = studentData
            .filter(student => student.EXAM_TYPE === "Improvement")
            .map(student => student.CANDIDATE_ID)
            .join(",");

          const supplementaryIds = studentData
            .filter(student => student.EXAM_TYPE === "Supplementary")
            .map(student => student.CANDIDATE_ID)
            .join(",");
            setImprovementCandidateIds(improvementIds);
            setSupplementaryCandidateIds(supplementaryIds);
            
            // Store in localStorage as a comma-separated string
            localStorage.setItem("supplementaryIds", supplementaryIds);
            localStorage.setItem("improvementIds", improvementIds);
            
        } else {
          Swal.fire({
            icon: "info",
            title: "No Data Found",
            text: "No student records found for the selected center.",
          });
          setStudents([]);
          setFilteredStudents([]);
          setImprovementCandidateIds("");
          setSupplementaryCandidateIds("");
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        Swal.fire({
          icon: "warning",
          title: "Data not found!",
        });
      })
      .finally(() => setLoading(false));
  }, []);



  useEffect(() => {
    if (students.length > 0) {
      $(tableRef.current).DataTable({
        paging: false,
        info: false,
        destroy: true,
        columnDefs: [{ orderable: false, targets: 0 }],
      });
    }
  }, [students]);

  // useEffect(() => {
  //   const allSelected =
  //     students.length > 0 && Object.values(checkedItems).every(Boolean);
  //   setAllChecked(allSelected);
  // }, [checkedItems, students]);

  // const handleSelectAllChange = () => {
  //   const newCheckedState = {};
  //   students.forEach((student) => {
  //     newCheckedState[student.CANDIDATE_ID] = !allChecked; // Set all checkboxes based on allChecked state
  //   });

  //   setCheckedItems(newCheckedState);
  //   setAllChecked(!allChecked);
  // };

  // const handleCheckboxChange = (id) => {
  //   setCheckedItems((prevCheckedItems) => {
  //     const updatedCheckedItems = { ...prevCheckedItems, [id]: !prevCheckedItems[id] };
  //     const allSelected = students.every((student) => updatedCheckedItems[student.CANDIDATE_ID]);
  //     setAllChecked(allSelected);

  //     return updatedCheckedItems;
  //   });
  // };

  const GenerateSupplimentaryPDF = async () => {
    const token = localStorage.getItem("token");
    const CentCode = localStorage.getItem("CentCode");

    if (!token) {
      Swal.fire("Authentication Error", "Token is missing. Please log in.", "error");
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(
        `${config.API_BASE_URL}/Auth/GetCheckListData`,
        {
          candidatE_ID: supplementaryCandidateIds,
          centeR_CODE: CentCode,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      setLoading(false);

      const studentdata2 = response.data.data;
      if (response.status !== 200 || !response.data) {
        Swal.fire("Error", "Error fetching checklist data. Please try again.", "error");
        return;
      }

      // Encode the student data to pass in the URL
      const encodedData2 = encodeURIComponent(JSON.stringify(studentdata2));
      // console.log(encodedData);
      // Open the modal and pass the encoded data in the route URL
      openModal3(encodedData2); // Pass the encoded data to the openModal2 function
    } catch (error) {
      setLoading(false);
      console.error("Error generating checklist:", error);
      Swal.fire("Error", "An error occurred while generating the checklist.", "error");
    }
  };
  const GenerateImprovementPDF = async () => {
    const token = localStorage.getItem("token");
    const CentCode = localStorage.getItem("CentCode");

    if (!token) {
      Swal.fire("Authentication Error", "Token is missing. Please log in.", "error");
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(
        `${config.API_BASE_URL}/Auth/GetCheckListData`,
        {
          candidatE_ID: improvementCandidateIds,
          centeR_CODE: CentCode,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      setLoading(false);

      const studentdata = response.data.data;
      if (response.status !== 200 || !response.data) {
        Swal.fire("Error", "Error fetching checklist data. Please try again.", "error");
        return;
      }

      // Encode the student data to pass in the URL
      const encodedData = encodeURIComponent(JSON.stringify(studentdata));
      // console.log(encodedData);
      // Open the modal and pass the encoded data in the route URL
      openModal2(encodedData); // Pass the encoded data to the openModal2 function
    } catch (error) {
      setLoading(false);
      console.error("Error generating checklist:", error);
      Swal.fire("Error", "An error occurred while generating the checklist.", "error");
    }
  };


  const handleEditClick = (id) => {
    setStudentId(id);
    navigate(`/student-registration?mode=edit`);
  };
  const openModal2 = (encodedData) => {
    setChecklistData();
    localStorage.setItem("modalOpen", "true");
    $('#pdfModal').addClass('show').css('display', 'block');
    $('body').addClass('modal-open').append('<div class="modal-backdrop fade show"></div>');

    // Construct the URL with the encoded data
    const pdfUrl = `/improvement-checklist/${encodedData}`;
    // console.log(pdfUrl); // Log the URL for debugging

    // Open the modal with the pdfUrl (you can load the data into an iframe or render the document)
    if (iframeRef.current) {
      iframeRef.current.src = pdfUrl;
    }
  };
  const openModal3 = () => {
    setModalTitle("Supplementary Checklist");
    // if (!data) {
    //   console.error("No data provided to openModal3");
    //   return;
    // }
  
    // Store the full data in localStorage
    // localStorage.setItem("checklistData", JSON.stringify(data));
    // localStorage.setItem("modalOpen", "true");
  
    // console.log("Data stored in localStorage:", data);
  
    // Open the modal
    $('#pdfModal').addClass('show').css('display', 'block');
    $('body').addClass('modal-open').append('<div class="modal-backdrop fade show"></div>');
  
    // Load the PDF page
    if (iframeRef.current) {
      iframeRef.current.src = `/supplimentary-checklist`;
    }
  };
  const openModal4 = () => {
    setModalTitle("Improvement Checklist");
    // if (!data) {
    //   console.error("No data provided to openModal3");
    //   return;
    // }
  
    // Store the full data in localStorage
    // localStorage.setItem("checklistData", JSON.stringify(data));
    // localStorage.setItem("modalOpen", "true");
  
    // console.log("Data stored in localStorage:", data);
  
    // Open the modal
    $('#pdfModal').addClass('show').css('display', 'block');
    $('body').addClass('modal-open').append('<div class="modal-backdrop fade show"></div>');
  
    // Load the PDF page
    if (iframeRef.current) {
      iframeRef.current.src = `/improvement-checklist`;
    }
  };
  const movetodashboard = (e) =>{
    e.preventDefault();
    navigate("/dashboard");
  }
  const closeModal2 = () => {
    localStorage.removeItem("modalOpen");
    $("#pdfModal").removeClass("show").css("display", "none");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
    window.location.reload();
  };
  return (

    <div className="pc-container">
      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <div className="pc-content">
        <div className="page-header">
          <div className="page-block">
            <div className="row align-items-center">
              <div className="col-md-12 breadcrumb">
                <div className="page-header-title">
                  <h5 className="m-b-10">STUDENT'S LIST</h5>
                </div>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#" onClick={movetodashboard} >Home</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="#">Student's List</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="row" style={{ padding: "0px" }}>
          <div className="col-md-12">
            <div className="card tbl-card" style={{ border: "1px solid #1890ff" }}>

              <div className="card-body padding-10">
                {/* <div className="row" style={{ display: 'flex', justifyContent: 'end', marginBottom: '10px' }}>

                  <div className="col-md-2">
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Search..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                </div> */}
                <div className="table-responsive">
                  <table ref={tableRef} className="table table-hover table-bordered mb-0">
                    <thead>
                      <tr className="table-info">
                        {/* <th>
                          <input type="checkbox" checked={allChecked} onChange={handleSelectAllChange} />
                        </th> */}
                        <th>Sl. No</th>

                        <th>Roll No</th>
                        <th>Name of Candidate</th>
                        <th>Gender</th>
                        <th>Exam Type</th>
                        <th>Father’s Name</th>
                        <th>Mother’s Name</th>
                        <th>Category</th>
                        <th>Checklist Print Status</th>
                        <th>Challan Status</th>
                        <th className="text-start">Payment Status</th>
                        {/* <th>Action</th> */}
                      </tr>
                    </thead>
                    {filteredStudents.length > 0 ? (
                      <tbody>
                        {filteredStudents.map((student, index) => (
                          <tr key={student.CANDIDATE_ID}>
                            {/* <td>
                              <input
                                type="checkbox"
                                checked={checkedItems[student.CANDIDATE_ID] || false}
                                onChange={() => handleCheckboxChange(student.CANDIDATE_ID)}
                              />
                            </td> */}
                            <td>{index + 1}</td>

                            <td>{student.ROLL_NO}</td>
                            <td>{student.CAND_NAME}</td>
                            <td>{student.GENDER_NAME}</td>
                            <td>{student.EXAM_TYPE === "Improvement" ? "IMPROVEMENT" : "SUPPLEMENTARY"}</td>
                            <td>{student.FATHERS_NAME}</td>
                            <td>{student.MOTHERS_NAME}</td>
                            <td>{student.CATEGORY_NAME}</td>
                            <td>
                              {student.CHECKLIST_STATUS === "Printed" ? (
                                <span className="badge bg-light-success border border-success" style={{ fontSize: '12px' }}>Printed</span>
                              ) : (
                                <span className="badge bg-light-warning border border-warning" style={{ fontSize: '12px' }}>Not Printed</span>
                              )}<br />
                              <b>{student.CHECKLIST_PRINT_DATE_TIME || ""}</b>
                            </td>
                            <td>
                              {student.SUBMISSION_STATUS === "Generated" ? (
                                <span className="badge bg-light-success border border-success" style={{ fontSize: '12px' }}>Generated</span>
                              ) : (
                                <span className="badge bg-light-warning border border-warning" style={{ fontSize: '12px' }}>Not Generated</span>
                              )}
                            </td>
                            <td>
                              {student.PAYMENT_STATUS === "Completed" ? (
                                <span className="badge bg-light-success border border-success" style={{ fontSize: '12px' }}>Completed</span>
                              ) : (
                                <span className="badge bg-light-warning border border-warning" style={{ fontSize: '12px' }}>Not Completed</span>
                              )}
                            </td>
                            {/* <td>
                              {student.EXAM_TYPE !== "Supplementary" && student.SUBMISSION_STATUS !== "Generated" && (
                                <button
                                  className="btn btn-sm btn-primary text-white"
                                  onClick={() => handleEditClick(student.CANDIDATE_ID)}
                                >
                                  <i className="fa fa-edit"></i>&nbsp;Edit
                                </button>
                              )}

                            </td> */}
                          </tr>
                        ))}
                      </tbody>
                    ) : null}

                    {filteredStudents.length > 0 && (
                      <tfoot>
                        <tr>
                          <td colSpan={11}>
                            {improvementCandidateIds && improvementCandidateIds.trim() !== "" && (
                              <button
                                className="btn btn-success btn-sm"
                                style={{ marginRight: "15px" }}
                                onClick={openModal4}
                              >
                                <i className="fa fa-list"></i>&nbsp;Generate Improvement Checklist
                              </button>
                            )}
                            {supplementaryCandidateIds && supplementaryCandidateIds.trim() !== "" && (
                              <button className="btn btn-info btn-sm" onClick={openModal3}>
                                <i className="fa fa-list"></i>&nbsp;Generate Supplementary Checklist
                              </button>
                            )}
                          </td>
                        </tr>
                      </tfoot>
                    )}

                  </table>
                  {students.length === 0 && <div className="text-center text-danger mt-3">No data available</div>}
                </div>


              </div>
            </div>
          </div>
        </div>

        <div className="modal fade" id="pdfModal" role="dialog" tabIndex="-1">
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{modalTitle}</h5>
                <button type="button" className="btn-close" onClick={closeModal2}></button>
              </div>
              <div className="modal-body">
                <iframe ref={iframeRef} width="100%" height="500px" style={{ border: "none" }}></iframe>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={closeModal2}>Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ListContainer;